[
  {
    "id": "c1",
    "organizationId": "org-123",
    "text": "Erstbewertung abgeschlossen. Alle Dokumente sehen gut aus.",
    "date": "2024-11-15T10:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c2",
    "organizationId": "org-123",
    "text": "Warte auf zusätzliche Überprüfung durch die Rechtsabteilung.",
    "date": "2024-11-20T14:15:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c3",
    "organizationId": "org-123",
    "text": "Überprüfung wird fortgesetzt. Bitte auf Updates warten.",
    "date": "2024-11-21T10:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c3a",
    "organizationId": "org-123",
    "text": "Erste Phase abgeschlossen. Keine Probleme gefunden.",
    "date": "2024-11-22T09:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c3b",
    "organizationId": "org-123",
    "text": "Compliance-Check läuft. Bisher alles in Ordnung.",
    "date": "2024-11-23T14:20:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c3c",
    "organizationId": "org-123",
    "text": "Compliance-Check erfolgreich abgeschlossen.",
    "date": "2024-11-24T11:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c3d",
    "organizationId": "org-123",
    "text": "Finale Überprüfung läuft jetzt.",
    "date": "2024-11-25T08:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c3e",
    "organizationId": "org-123",
    "text": "Die Organisation erfüllt alle Anforderungen und wurde nach sorgfältiger Prüfung genehmigt.",
    "date": "2024-11-25T15:00:00Z",
    "author": "Admin User",
    "type": "APPROVAL"
  },
  {
    "id": "c3f",
    "organizationId": "org-123",
    "text": "Onboarding-Prozess hat begonnen. Willkommen!",
    "date": "2024-11-26T10:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4",
    "organizationId": "org-456",
    "text": "Dokumente eingegangen. Überprüfung läuft.",
    "date": "2024-11-18T11:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4a",
    "organizationId": "org-456",
    "text": "Überprüfung wird fortgesetzt. Bitte auf Updates warten.",
    "date": "2024-11-20T09:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4b",
    "organizationId": "org-456",
    "text": "Erste Phase der Überprüfung abgeschlossen. Keine Probleme gefunden.",
    "date": "2024-11-21T13:20:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4c",
    "organizationId": "org-456",
    "text": "Zusätzliche Dokumente angefordert zur vollständigen Überprüfung.",
    "date": "2024-11-22T10:15:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4d",
    "organizationId": "org-456",
    "text": "Zusätzliche Unterlagen erhalten. Analyse läuft.",
    "date": "2024-11-23T08:45:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4e",
    "organizationId": "org-456",
    "text": "Finale Überprüfung durch das Compliance-Team läuft.",
    "date": "2024-11-24T11:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4f",
    "organizationId": "org-456",
    "text": "Compliance-Team hat ihre Überprüfung abgeschlossen. Ergebnis positiv.",
    "date": "2024-11-25T09:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4g",
    "organizationId": "org-456",
    "text": "Alle erforderlichen Überprüfungen abgeschlossen. Wartet auf finale Genehmigung durch Management.",
    "date": "2024-11-26T14:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4h",
    "organizationId": "org-456",
    "text": "Management-Überprüfung läuft. Entscheidung wird getroffen.",
    "date": "2024-11-27T10:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c4i",
    "organizationId": "org-456",
    "text": "Wartet noch auf finale Entscheidung. Erwarten Update morgen.",
    "date": "2024-11-28T15:45:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5",
    "organizationId": "org-789",
    "text": "Dokumente eingegangen. Überprüfung startet.",
    "date": "2024-11-18T09:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5a",
    "organizationId": "org-789",
    "text": "Erste Überprüfung zeigt Mängel in der Dokumentation.",
    "date": "2024-11-20T13:15:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5b",
    "organizationId": "org-789",
    "text": "Fehlende Unterlagen angefordert.",
    "date": "2024-11-22T13:45:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5c",
    "organizationId": "org-789",
    "text": "Angeforderte Unterlagen nicht eingegangen. Erinnerung gesendet.",
    "date": "2024-11-24T10:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5d",
    "organizationId": "org-789",
    "text": "Erneute Überprüfung der eingereichten Dokumente läuft.",
    "date": "2024-11-25T14:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5e",
    "organizationId": "org-789",
    "text": "Überprüfung zeigt weiterhin erhebliche Mängel.",
    "date": "2024-11-26T11:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5f",
    "organizationId": "org-789",
    "text": "Letzte Chance für die Organisation, fehlende Dokumente nachzureichen.",
    "date": "2024-11-27T09:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5g",
    "organizationId": "org-789",
    "text": "Frist abgelaufen. Keine neuen Dokumente eingegangen.",
    "date": "2024-11-28T16:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c5h",
    "organizationId": "org-789",
    "text": "Die eingereichten Dokumente erfüllen nicht die erforderlichen Standards. Antrag wurde abgelehnt.",
    "date": "2024-11-28T17:00:00Z",
    "author": "Admin User",
    "type": "REJECTION"
  },
  {
    "id": "c6",
    "organizationId": "org-234",
    "text": "Bewerbung eingegangen und wird derzeit bewertet.",
    "date": "2024-11-21T10:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c6a",
    "organizationId": "org-234",
    "text": "Initiale Überprüfung läuft.",
    "date": "2024-11-22T14:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c6b",
    "organizationId": "org-234",
    "text": "Einige Fragen zu den eingereichten Dokumenten.",
    "date": "2024-11-23T11:15:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c6c",
    "organizationId": "org-234",
    "text": "Warte auf Antworten von der Organisation.",
    "date": "2024-11-24T09:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c6d",
    "organizationId": "org-234",
    "text": "Antworten erhalten und werden überprüft.",
    "date": "2024-11-25T13:45:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c6e",
    "organizationId": "org-234",
    "text": "Weitere Klarstellungen erforderlich.",
    "date": "2024-11-26T10:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c6f",
    "organizationId": "org-234",
    "text": "Noch ausstehend: Compliance-Check.",
    "date": "2024-11-27T15:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c7",
    "organizationId": "org-567",
    "text": "Hochwertige Unterlagen eingereicht. Erste Überprüfung sehr positiv.",
    "date": "2024-11-19T09:15:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c7a",
    "organizationId": "org-567",
    "text": "Alle erforderlichen Dokumente vorhanden und vollständig.",
    "date": "2024-11-20T14:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c7b",
    "organizationId": "org-567",
    "text": "Compliance-Check durchgeführt. Keine Probleme.",
    "date": "2024-11-22T11:30:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c7c",
    "organizationId": "org-567",
    "text": "Rechtliche Überprüfung abgeschlossen. Alles in Ordnung.",
    "date": "2024-11-23T15:45:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c7d",
    "organizationId": "org-567",
    "text": "Finale Überprüfung läuft.",
    "date": "2024-11-24T10:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c7e",
    "organizationId": "org-567",
    "text": "BioMed Research erfüllt alle Kriterien für die Zulassung. Genehmigung erteilt.",
    "date": "2024-11-26T15:30:00Z",
    "author": "Admin User",
    "type": "APPROVAL"
  },
  {
    "id": "c7f",
    "organizationId": "org-567",
    "text": "Willkommen in unserem Netzwerk! Onboarding wird eingeleitet.",
    "date": "2024-11-27T12:00:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  },
  {
    "id": "c7g",
    "organizationId": "org-567",
    "text": "Onboarding-Materialien wurden versendet.",
    "date": "2024-11-28T10:15:00Z",
    "author": "Admin User",
    "type": "COMMENT"
  }
]
